import container from '@/mixins/container.js'
import { Sprite } from 'pixi.js'

export default {
  mixins: [
    container
  ],

  props: {
    anchor: {
      type: Array
    },

    angle: {
      type: Number
    },

    rotation: {
      type: Number
    },

    alpha: {
      type: Number
    },

    tint: {
      type: String
    },

    src: {
      type: [ Number, String, Object ]
    }
  },

  computed: {
    displayObject () {
      return this.src
        ? Sprite.from(this.src)
        : new Sprite()
    }
  },

  methods: {
    updateProp (key, value) {
      if (key === 'anchor') {
        if (value instanceof Array) {
          this.displayObject.anchor.set(value[0], value[1])
        } else {
          this.displayObject.anchor.set(0, 0)
        }

        return true
      }
    }
  }
}
